import { ICategoryGalleryBlockTag } from '@features/cms/typescript';
import { ICategoryFilterValue } from '@features/cms/components/categories/CategoryGalleryBlock/typescript';
class CategoryGalleryFilterState {
  public code: string;
  public name: string;
  public values: ICategoryFilterValue[];
  constructor(filter: ICategoryGalleryBlockTag) {
    this.code = filter.code;
    this.name = filter.name;
    this.values = filter.values;
  }
  getValuesCount() {
    return this.values.length;
  }
  addValue = (value: ICategoryFilterValue) => {
    if (this.values.some(val => val.code === value.code)) return;
    this.values.push(value);
  };
  removeValue = (valueCode: string) => {
    this.values = this.values.filter(value => value.code !== valueCode);
  };
  removeAllValues = () => {
    this.values = [];
  };
}
export default CategoryGalleryFilterState;